import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTankCovered = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 75,
	viewBox: "0 0 100.0 75.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 5.0 5.0 L 5.0 75.0 L 95.0 75.0 L 95.0 5.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 10.0 L 0.0 0.0 L 100.0 0.0 L 100.0 10.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgTankCovered;
